import { useQuery } from "@tanstack/react-query";
import { Navigate, useLocation } from "react-router-dom";
import type { ReactNode } from "react";
import { tenantApi } from "../lib/tenant";

export function OnboardingGate({ children }: { children: ReactNode }) {
  const location = useLocation();
  const { data, isLoading } = useQuery({
    queryKey: ["tenant"],
    queryFn: () => tenantApi.getMe(),
  });

  if (isLoading) {
    return (
      <div className="stage" style={{ color: "var(--ink-3)" }}>Loading…</div>
    );
  }

  // Force users into onboarding until they've reached the "ready" step.
  if (data && data.onboarding_step !== "ready" && !location.pathname.startsWith("/onboarding")) {
    return <Navigate to="/onboarding" replace />;
  }
  return <>{children}</>;
}
